import Link from 'next/link';
import Avatar from './Avatar';
import DateComponent from './Date';
import CoverImage from './CoverImage';
import { useRouter } from 'next/router';
import { analytics } from '../../lib/analytics';

export default function HeroPost({
  title,
  coverImage,
  date,
  excerpt,
  author,
  slug,
}) {
  const router = useRouter();
  const app = router.query.app;
  const link = `/blog/${slug}${app ? '?app=true' : ''}`;

  return (
    <section>
      <div className="md:grid md:grid-cols-2 md:gap-x-16 lg:gap-x-8">
        <div className="my-8 w-full">
          <CoverImage
            title={title}
            slug={slug}
            url={coverImage.url}
            height={coverImage.height}
            width={coverImage.width}
            link={link}
          />
        </div>
        <div className="my-auto">
          <div>
            <h3 className="mt-0 mb-4 text-2xl lg:text-5xl leading-tight">
              <Link
                href={link}
                className="hover:underline"
                onClick={() => {
                  analytics.track('User Clicked Hero Blog', {
                    title,
                    slug,
                  });
                }}
              >
                {title}
              </Link>
            </h3>
            <div className="mb-4 md:mb-0 text-lg">
              <DateComponent dateString={date} />
            </div>
          </div>
          <div>
            <p className="text-lg leading-relaxed mb-4">{excerpt}</p>
            {author && <Avatar name={author.name} picture={author.picture} />}
          </div>
        </div>
      </div>
    </section>
  );
}
